import path from 'path';

import React from 'react';
import PropTypes from 'prop-types';
import DocumentMeta from 'react-document-meta';
import { Route, Switch, withRouter } from 'react-router-dom';

import * as Dynamic from 'pages/index';
import CloudImageComponent from 'components/ui/CloudImageComponent';

const App = ({ location }) => {
  const logoURL = CloudImageComponent({
    publicId: 'glue/identity/logo/logo-square',
    fetchFormat: 'png',
    dpr: '3',
    width: '350',
    getURL: true,
  });

  const defaultMetaTags = {
    title: 'Glue – Digital Development',
    description: 'We are a creative app, web & platform development agency. We design and build strong digital experiences.',
    meta: {
      charset: 'utf-8',
      name: {
        keywords: 'glue,agency,software,web,development,design,app,platform,innovation,creative,gastrobuddy,mrflavour,tape,haarlem,amsterdam',
      },
      property: { 'og:image': logoURL },
    },
    auto: { ograph: true },
  };

  return (
    <>
      <DocumentMeta
        canonical={path.join(process.env.REACT_APP_URL, location.pathname)}
        {...defaultMetaTags} />

      <Switch>
        <Route exact path="/" component={Dynamic.IndexPage} key="IndexPage" />
        <Route exact path="/cases" component={Dynamic.CaseOverviewPage} key="CaseOverviewPage" />
        <Route exact path="/process" component={Dynamic.ProcessPage} key="ProcessPage" />
        <Route exact path="/about" component={Dynamic.AboutPage} key="AboutPage" />
        <Route exact path="/contact" component={Dynamic.ContactPage} key="ContactPage" />
        <Route
          path="/inkoopvoorwaarden"
          component={() => {
            window.location.href = 'https://s3.eu-west-2.amazonaws.com/glue.group/storage/AIV_2020_09_14_GlueBV.pdf';
            return null;
          }} />
        <Route
          path="/cases/:slug"
          key="CaseDetailPage"
          render={({ match }) => {
            const { slug } = match.params;

            const enter = location?.state?.enter; // eslint-disable-line
            const exit = location?.state?.exit; // eslint-disable-line
            const classNames = { enter, exit };

            return <Dynamic.CaseDetailPage slug={slug} animations={classNames} location={location} />;
          }} />
      </Switch>
    </>
  );
};

App.propTypes = {
  location: PropTypes.object.isRequired, // eslint-disable-line
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/app.js